import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { basicHeaders, legacyFulfill } from "../utils";
import {
  LICENSE_RECEIVED_CONSUME_LICENSE,
  LICENSE_RECEIVED_GET_LICENSE_REPORT,
  LICENSE_RECEIVED_GET_LICENSE_REPORT_LIST,
  LICENSE_RECEIVED_UPDATE_LICENSES,
} from "../../legacy/actions/license-actions";

export interface LocationReport {
  id: number;
  asset_serial: string;
  asset_type: string;
  license_serial: string;
  created_at: string;
  updated_at: string;
  po_number: string;
  location_id: number;
  jde_number: string;
  sf_number: string;
  consumed: boolean;
  consumed_at: string;
}
export const locationReportApi = createApi({
  reducerPath: "locationReportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_LICENSE_SERVICE}`,
    prepareHeaders: basicHeaders,
  }),
  tagTypes: ["locationReport"],
  endpoints: (builder) => ({
    consumeLicense: builder.query<LocationReport, LocationReport[]>({
      query: (licenses) => ({
        url: "service/consume-license",
        method: "PUT",
        body: licenses,
      }),
      onQueryStarted: legacyFulfill(LICENSE_RECEIVED_CONSUME_LICENSE),
    }),
    getLocationReport: builder.query<LocationReport, number>({
      query: (locationId) => `/location-report/${locationId}`,
      onQueryStarted: legacyFulfill(LICENSE_RECEIVED_GET_LICENSE_REPORT),
    }),
    getLocationReportList: builder.mutation<LocationReport, { list: number[] }>(
      {
        query: (list) => ({
          url: '"/location-report"',
          method: "PUT",
          body: { location_ids: list },
        }),
        onQueryStarted: legacyFulfill(LICENSE_RECEIVED_GET_LICENSE_REPORT_LIST),
      }
    ),
    updateLicenses: builder.mutation<
      LocationReport,
      { id: string; data: Partial<LocationReport> }
    >({
      query: (list) => ({
        url: `/update-license`,
        method: "/update-license",
        body: { licenses: list },
      }),
      onQueryStarted: legacyFulfill(LICENSE_RECEIVED_UPDATE_LICENSES),
    }),
    getLicenseStatus: builder.query<LocationReport[], string[]>({
      query: (list) => ({
        url: "/license-status",
        method: "PUT",
        body: {
          assets: list.map((a) => {
            return { asset_serial: a };
          }),
        },
      }),

      providesTags: ["locationReport"],
    }),
  }),
});

export const {
  useConsumeLicenseQuery,
  useGetLocationReportQuery,
  useUpdateLicensesMutation,
  useGetLocationReportListMutation,
  useLazyGetLocationReportQuery,
  useLazyConsumeLicenseQuery,
  useGetLicenseStatusQuery,
} = locationReportApi;
